import api from "@/plugins/api";
/** Helper: unwrap BFF ApiResponse<T> envelope → T */
function unwrap(apiResponse) {
    return apiResponse.data;
}
export async function searchSubscriptions(params) {
    const response = await api.get("/portal/subscriptions/search", {
        params: {
            donorId: params?.donorId,
            contactId: params?.contactId,
            organizationId: params?.organizationId,
            status: params?.status,
            frequency: params?.frequency,
            page: params?.page,
            pageSize: params?.perPage,
            sortBy: params?.sortBy,
            sortOrder: params?.sortOrder,
        },
    });
    // Search returns ApiResponse<List<T>> — mapApiPaginated reads .data directly
    return response.data;
}
export async function getSubscription(subscriptionId) {
    const response = await api.get(`/portal/subscriptions/${subscriptionId}`);
    return unwrap(response.data);
}
export async function createSubscription(payload) {
    const response = await api.post("/portal/subscriptions", payload);
    return unwrap(response.data);
}
export async function updateSubscription(subscriptionId, payload) {
    const response = await api.put(`/portal/subscriptions/${subscriptionId}`, payload);
    return unwrap(response.data);
}
export async function pauseSubscription(subscriptionId) {
    const response = await api.put(`/portal/subscriptions/${subscriptionId}/pause`);
    return unwrap(response.data);
}
export async function resumeSubscription(subscriptionId) {
    const response = await api.put(`/portal/subscriptions/${subscriptionId}/resume`);
    return unwrap(response.data);
}
export async function cancelSubscription(subscriptionId, reason) {
    const response = await api.put(`/portal/subscriptions/${subscriptionId}/cancel`, {
        reason: reason ?? null,
    });
    return unwrap(response.data);
}
export async function getSubscriptionDonations(subscriptionId, params) {
    const response = await api.get(`/portal/subscriptions/${subscriptionId}/donations`, {
        params: {
            page: params?.page,
            pageSize: params?.perPage,
        },
    });
    // Returns ApiResponse<List<T>> — mapApiPaginated reads .data directly
    return response.data;
}
